import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";
import { useState, useEffect } from "react";
import { ReactComponent as IncrementIcon } from "../../../../assets/images/events/increment.svg";
import { ReactComponent as Pencil } from "../../../../assets/images/events/pencil.svg";
import { ReactComponent as Trash } from "../../../../assets/images/events/trash.svg";
import { useIsMobileHook } from "../../../../utils/WindowHooks";
import { apiGetEventCoupons } from "../../../../api/events";
import CouponModal from "../CouponModal/CouponModal";
import "./CouponsSection.scss";

const CouponsSection = ({ eventId, coupons, setCoupons, toDeleteCoupons, setToDeleteCoupons }) => {
  const [isCouponModalVisible, setIsCouponModalVisible] = useState(false);
  const [isEditingCoupon, setIsEditingCoupon] = useState(false);
  const [editingCouponId, setEditingCouponId] = useState(null);
  const [editingCoupon, setEditingCoupon] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const isMobile = useIsMobileHook(1500);

  const openModalToEdit = (coupon) => {
    setIsEditingCoupon(true);
    setEditingCouponId(coupon.id);
    setEditingCoupon(coupon);
    setIsCouponModalVisible(true);
  };

  const handleDeleteCoupon = (record) => {
    setToDeleteCoupons(prev => [...prev, record]);
    const updatedCoupons = coupons.filter(coupon => coupon.id !== record.id);
    setCoupons(updatedCoupons);
    setIsCouponModalVisible(false);
  };

  const showDeleteConfirm = (record) => {
    Modal.confirm({
      title: 'Tem certeza que deseja excluir esse cupom?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Sim',
      okType: 'primary',
      cancelText: 'Não',
      className: 'custom-delete-modal',
      onOk() {
        handleDeleteCoupon(record);
      },
      onCancel() {
        console.log('Cancelado');
      },
    });
  };


  const formatCouponValue = (value, type) => {
    if (type === 'PERCENTAGE') {
      return `${value}%`;
    } else if (type === 'FIXED') {
      return `R$ ${(value / 100).toFixed(2).replace('.', ',')}`;
    }
    return value;
  };

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Código',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (type) => (
        <span>{type === 'PERCENTAGE' ? 'Porcentagem' : 'Valor Fixo'}</span>
      ),
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      render: (value, record) => (
        <span className="coupon-value">{formatCouponValue(value, record.type)}</span>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div className="coupon-actions">
          <Pencil role="button" onClick={() => openModalToEdit(record)} className="button-coupon" />
          <Trash role="button" onClick={() => showDeleteConfirm(record)} className="button-coupon" />
        </div>
      ),
      responsive: ["md"],
    },
  ];

  const handleRowClick = (record) => {
    const id = record.id;
    if (expandedRowKeys.includes(id)) {
      setExpandedRowKeys(expandedRowKeys.filter(key => key !== id));
    } else {
      setExpandedRowKeys([id]);
    }
  };

  const expandedRowRender = (record) => (
    <div className="expandid">
      <div className="coupon-actions">
        <Pencil role="button" onClick={() => openModalToEdit(record)} className="button-coupon" />
        <Trash role="button" onClick={() => showDeleteConfirm(record)} className="button-coupon" />
      </div>
    </div>
  );

  const openModal = () => {
    setIsCouponModalVisible(true);
    setIsEditingCoupon(false);
    setEditingCoupon(null);
  };

  const handleCloseModal = () => {
    setIsCouponModalVisible(false);
    setEditingCoupon(null);
    setIsEditingCoupon(false);
  };

  return (
    <div className="coupons-section">
      <div className="container-button">
        <div className="title-and-button">
          <div className="title-container">
            <p>Cupons de desconto</p>
          </div>
          {coupons.length > 0 && (
            <Button onClick={openModal} className="custom-btn">
              <IncrementIcon /> Criar um cupom
            </Button>
          )}
        </div>

        {coupons.length === 0 && (
          <div className="empty-coupons">
            <Button onClick={openModal} className="custom-btn">
              <IncrementIcon /> Criar um cupom
            </Button>
          </div>
        )}

        {coupons.length > 0 && (
          <Table
            tableLayout="fixed"
            columns={columns}
            dataSource={coupons}
            rowKey="id"
            expandable={{
              expandedRowRender: isMobile ? expandedRowRender : undefined,
              expandedRowKeys: expandedRowKeys,
              onExpand: (_, record) => handleRowClick(record),
              responsive: ["xl"],
            }}
          />
        )}
      </div>

      <CouponModal
        visible={isCouponModalVisible}
        onClose={handleCloseModal}
        setIsCouponModalVisible={setIsCouponModalVisible}
        isEditing={isEditingCoupon}
        setCoupons={setCoupons}
        coupons={coupons}
        setEditingCouponId={setEditingCouponId}
        editingCouponId={editingCouponId}
        editingCoupon={editingCoupon}
      />
    </div>
  );
};

export default CouponsSection;